module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_39.802c35f2.jpg";